import { classnames, fNumber } from '@aibees/shared/utils';
import { Box, LinearProgress, Typography } from '@mui/material';
import { memo } from 'react';
import { Icon } from '../icon';
import { Label } from '../label';
import * as Styled from './styles';
import * as SX from './sx';
import type { ProgressBarProps as Props } from './types';

export const ProgressBar = memo(
  ({ className, icon, title, current, total, color, ...rest }: Props) => {
    const percentage = Math.min(((current ?? 0) / total!) * 100, 100);

    return (
      <Styled.Wrapper
        className={classnames('ProgressBar', className)}
        sx={SX.root}
      >
        <Styled.Top>
          <Styled.Column>
            {icon && <Icon name="info-circle-outline" size={16} />}
            {title && (
              <Typography variant="body4" color="grey.700" fontWeight={600}>
                {title}
              </Typography>
            )}
          </Styled.Column>
          <Styled.Column>
            {current !== undefined && total !== undefined && (
              <Typography variant="body4" color="grey.700">
                <b>{fNumber(current)}</b> / {fNumber(total)}
              </Typography>
            )}
            {percentage !== undefined && (
              <Label sx={{ width: 'auto' }} color="default">
                {percentage}%
              </Label>
            )}
          </Styled.Column>
        </Styled.Top>
        <Box>
          <LinearProgress
            color={color}
            variant="determinate"
            value={percentage}
            {...rest}
          />
        </Box>
      </Styled.Wrapper>
    );
  }
);

ProgressBar.displayName = 'ProgressBar';
